import React,{useState,}from 'react'
import {Modal,Form, Button,DatePicker,Input, Radio,} from 'antd';
import GetClient from '../client/GetClient'
import GetDept from '../../cpn/GetDept';
import dayjs from 'dayjs';
const { RangePicker } = DatePicker;
function ArapQuery(props) {
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    return (
        <>
            <Button style={{marginLeft:'10px'}} onClick={() => {setOpen(true)}}>查询</Button>
            <Modal 
                width={700}
                open={open} 
                title='查询收支单'
                okText="提交"
                cancelText="取消"
                footer={(_, { OkBtn, CancelBtn }) => (
                    <>
                        <Button onClick={() => {                                                  
                            localStorage.setItem('arapWait_query_dept','')
                            localStorage.setItem('arapWait_query_client','')
                            localStorage.setItem('arapWait_query_team_num','')
                            localStorage.setItem('arapWait_query_date_s','')
                            localStorage.setItem('arapWait_query_date_e','')
                            localStorage.setItem('arapWait_query_action','')
                            localStorage.setItem('arapWait_query_ysyf_type','')
                            setOpen(false)
                            props.getQuery({action:'',ysyf_type:'',eie_client_id:'',eie_arrive_date_s:'',ebn_team_num:'',eie_dept_id:'',ebn_date_s:''})                                    
                            form.resetFields();        
                            }}>重置</Button>
                        <CancelBtn />
                        <OkBtn />
                    </>
                )}
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            console.log(values);
                            props.getQuery({
                                action:"search",
                                ebn_date_s:values.ebn_date_s?dayjs(values.ebn_date_s[0]).format('YYYY-MM-DD'):'',
                                ebn_date_e:values.ebn_date_s?dayjs(values.ebn_date_s[1]).format('YYYY-MM-DD'):'',
                                eie_dept_id:values.eie_dept_id,
                                eie_client_id:values.eie_client_id,
                                ebn_team_num:values.ebn_team_num,                                
                                ysyf_type:values.ysyf_type,                                
                            })
                            setOpen(false)  
                            localStorage.setItem('arapWait_query_dept',values.eie_dept_id)
                            localStorage.setItem('arapWait_query_client',values.eie_client_id)
                            localStorage.setItem('arapWait_query_team_num',values.ebn_team_num)
                            localStorage.setItem('arapWait_query_ysyf_type',values.ysyf_type)
                            localStorage.setItem('arapWait_query_date_s',values.ebn_date_s?dayjs(values.ebn_date_s[0]).format('YYYY-MM-DD'):'')
                            localStorage.setItem('arapWait_query_date_e',values.ebn_date_s?dayjs(values.ebn_date_s[1]).format('YYYY-MM-DD'):'')
                            localStorage.setItem('arapWait_query_action','search')
                        })
                        .catch((info) => {
                            console.log('Validate Failed:', info);
                        });           
                }}
            >
                <Form 
                    form={form}
                    layout="horizonal"
                    name="form_in_modal"
                    initialValues={{                        
                        eie_client_id:localStorage.getItem('arapWait_query_client'),
                        // eie_arrive_date_s:[
                        //     localStorage.getItem('arapWait_query_arrive_date_s')?localStorage.getItem('arapWait_query_arrive_date_s'):'',
                        //     localStorage.getItem('arapWait_query_arrive_date_e')?localStorage.getItem('arapWait_query_arrive_date_e'):''
                        // ],
                        // ebn_date_s:[
                        //     localStorage.getItem('arapWait_query_date_s')?localStorage.getItem('arapWait_query_date_s'):'',
                        //     localStorage.getItem('arapWait_query_date_e')?localStorage.getItem('arapWait_query_date_e'):''
                        // ],
                        ebn_team_num:localStorage.getItem('arapWait_query_team_num'),
                        eie_dept_id:localStorage.getItem('arapWait_query_dept'),
                        ysyf_type:localStorage.getItem('arapWait_query_ysyf_type'),
                    }}
                    labelCol={{ span: 5 }}   
                >
                    <GetClient 
                        label='客户'  
                        wrapperCol={{span:15}} 
                        name='eie_client_id' 
                        style={{width:'290px'}} 
                        getClient={(e) => {}} 
                    />   
                    <Form.Item 
                        name='ebn_date_s' 
                        label='出发日期'
                    >                                    
                        <RangePicker />
                    </Form.Item>
                    <Form.Item 
                        name='ebn_team_num' 
                        label='团号' 
                        wrapperCol={{span:10}}
                    >                                    
                        <Input />
                    </Form.Item>
                    <GetDept 
                        label='部门' 
                        wrapperCol={{span:10}} 
                        name='eie_dept_id' 
                        getDept={() => {}}
                    />
                    <Form.Item 
                        name='ysyf_type' 
                        label='类型' 
                        wrapperCol={{span:10}}
                    >                                    
                        <Radio.Group>
                            <Radio value=''>全部</Radio>
                            <Radio value='2'>收入单</Radio>
                            <Radio value='1'>支出单</Radio>
                        </Radio.Group>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default ArapQuery